import template from './quotes.html';
import controller from './quotes.controller';

let quotesComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default quotesComponent;
